var _rect, _path, _path2, _rect2, _rect3, _rect4, _path3, _path4, _rect5, _rect6, _rect7, _rect8, _path5, _path6, _path7, _path8, _rect9, _path9, _path0, _path1, _rect0, _rect1, _rect10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSystem = function SvgSystem(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 40",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 39,
    x: 0.5,
    y: 0.5,
    fill: "#F4F7FC",
    stroke: "#D2D5E1",
    rx: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M1 4a3 3 0 0 1 3-3h8v38H4a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EAEDF7",
    d: "M12.5 1v38"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 2,
    x: 4,
    y: 8,
    fill: "#7C88B1",
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 2,
    x: 4,
    y: 13,
    fill: "#7C88B1",
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 2,
    x: 4,
    y: 18,
    fill: "#7C88B1",
    rx: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13 1h19v7H13z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EAEDF7",
    d: "M13 8.5h19"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 23,
    x: 17,
    y: 12,
    fill: "#FFF",
    rx: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 2,
    x: 20,
    y: 16,
    fill: "#242F57",
    rx: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 2,
    x: 20,
    y: 21,
    fill: "#D2D5E1",
    rx: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 2,
    x: 20,
    y: 26,
    fill: "#D2D5E1",
    rx: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#12151F",
    d: "M32 .5h28A3.5 3.5 0 0 1 63.5 4v32a3.5 3.5 0 0 1-3.5 3.5H32z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3140",
    d: "M32 .5h28A3.5 3.5 0 0 1 63.5 4v32a3.5 3.5 0 0 1-3.5 3.5H32"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1F2B",
    d: "M32 1h28a3 3 0 0 1 3 3v4H32z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3140",
    d: "M32 8.5h31"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 3,
    x: 54,
    y: 3,
    fill: "#369AFE",
    rx: 1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1F2B",
    d: "M32 12h10a2 2 0 0 1 2 2v19a2 2 0 0 1-2 2H32z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E9F2",
    d: "M32 16h1a1 1 0 1 1 0 2h-1z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A5064",
    d: "M32 21h7a1 1 0 1 1 0 2h-7zM32 26h4a1 1 0 1 1 0 2h-4z"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 23,
    x: 47,
    y: 12,
    fill: "#1B1F2B",
    rx: 2
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2,
    x: 49,
    y: 16,
    fill: "#E6E9F2",
    rx: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 2,
    x: 49,
    y: 21,
    fill: "#4A5064",
    rx: 1
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSystem);
export default ForwardRef;